enum TextAreaValidations {
  VALID = 'valid',
  INVALID = 'invalid',
  DEFAULT = 'default',
}
export { TextAreaValidations };
